<template>
  <div :class="[ routineProduct ? '':' cell', 'commerce-connector']">
  <template v-if="!isSingleVariant">
    <div class="buyOnline -btnOnly" v-if="this.showBuyNowButton==true && !isBuyOnline && !stickyBuynowButton">
      <div @click="buybuttonselect()" class="popupContainer__bagIcon">
        <img alt="bag" src="/frontend/master/images/icons/bag.svg">
      </div>
      <div :class="ctaClass">
        <span @click="buybuttonselect()" class="btn__wrapper" v-tag:useractionevent="{
                  category: 'Ecommerce',
                  action: 'click to buy',
                  label: buynowEventlabelData,
                  event_name: 'buy_now',
                  product_info: buynowEventlabelData
                }">
          {{ buynowTextData }}
        </span>
      </div>
    </div>
    <div v-else-if="isBuyOnline && !stickyBuynowButton ">
      <template v-if="productPopinCtaClass !== ''">
        <button @click="buybuttonselect()" :class="productPopinCtaClass" >
          <span class="btn__wrapper">
            {{ buynowTextData }}
          </span>
        </button>
      </template>
      <template v-else>
        <button type="button" class="actionBtn buyOnline" @click="buybuttonselect()"> {{ buynowTextData }} </button>
      </template>
    </div>
    <div v-if="stickyBuynowButton">
      <button type="button" class="actionBtn buyOnline" @click="mobilebuybutton()"> {{ buynowTextData }} </button>
    </div>
  </template>
  <div class="popupContainerOuter-overlay" :class="{ 'showPopup': showPopup }"></div>
  <div class="popupContainerOuter popupWrapper" id="popupContainerOuter" :class="{ 'showPopup': showPopup }"> 
      <div class="popupRetailer"  >
        <div class="popup-title__container">
          <h2 class="popup-heading"><span  v-if="this.eretailer[0]?.enableBuynowSortOption">{{this.eretailer[0]?.retailerDictionaryDatas.buyOnline}}</span></h2>
          <button ref="accessibilityfocus" class="popupCLose" @click="closePopupScreen()" tabindex="0"></button>
        </div>
        <h3 class="popup-slectShop" v-if="this.eretailer[0]?.enableBuynowSortOption"> {{this.eretailer[0]?.retailerDictionaryDatas.selectShop}}   </h3>

        <div class="retailer-sorting__container"  v-if="this.eretailer[0]?.enableBuynowSortOption && this.eretailer.length > 0">
 
          <customSorting ref="retailer_sorting" :sortlabel="retailerDatas.sortBy" :options="dropdownItem" :default="retailerDatas.defaultText" class="select"
            @getInput="sortOrder = $event" />
        </div>
        <div class="tabs" v-if="this.eretailer.length > 0" >
          <ul>
            <li v-for="(tab, index) in this.eretailer" :class="{'is-active': show == index}" @click.prevent="show = index" :key="index">
               {{ tab.countryCode }} 
            </li>
          </ul>
        </div>
        
        <div class="tabData">
         
        <transition-group name="fade-up" target="div" appear @click.native="navigate($event)">
         
          <div v-for="(tab, index) in this.eretailer" v-if="show == index " :key="index"> 
           
            <div class="retailer-count" v-if="tab.enableBuynowSortOption && tab.shopsUnavailable == false">{{tab.shops.length}} {{retailerDatas.onlineShoping}} </div>
            <div  id="commerceConnectWrapper" v-if="tab.shopsUnavailable==false">
              <div>
          <div class="retailer-shop__container"  v-for="shop in sortedItems" :key="shop.id">
            <div class="retailer-shop-wrapper">
              <div class="retailer-shop-img">
                <img :src="shop.logo" alt="shop" width="130" height="70"
                  class="" />
              </div>
              <div class="retailer-shop-name-wrapper">
                <span class="retailer-name"  > {{ shop.title }} </span>
                <span class="retailer-price" v-if="shop.price">{{shop.price}}</span>
              </div>
            </div>
            <div class="retailer-shop-instock" v-if="shop.stockAvailability">
              {{shop.stockAvailability}}
            </div>
            <div class="retailer-shop-deliveryTime" v-if="shop.deliveryTime">
               {{retailerDatas.deliveryTimeLabel}}<strong> {{shop.deliveryTime}}</strong>
            </div>
            <div class="retailer-shop-buyNow" v-if="shop.link">
              <a :href="shop.link" @click="setAnalytics(shop.cartTagging)"
                
                target="_blank" class="cta cta--light" panel-focusable=""> {{ shop.buyButton }}</a>

            </div>
          </div>
        </div> 
            </div>
            <div class="popupContainer__inner" id="commerceConnectWrapper" v-else>
              {{ tab.defaultDescriptionTitle }}
            </div>
          </div>
        </transition-group>
      </div>
     
        
      </div>
    
 
     
  </div>
  <div class="popupContainerOuter variantPopupOuter capacityPopupContainerOuterroutine" id="capacityPopupContainerOuter" v-show="capacityPopup" :class="{'capacityPopup' : capacityPopup}">
    <div class="variant popupContainer" v-if="capacityPopup">
      <div class="popupContainer__close" @click="closecapacityPopupScreen()">&#10006;</div>
      <div class="container pdp-stikcy-bar" id="app">
        <div class="sticky-parent">
          <div class="sticky__heading">
            <img :src="productImg" alt="product images">
          </div>
          <div class="sticky__select">
            <div class="sticky__title" v-html="pfdTitle" />
            <div class="sticky__select--select_capacity">
              <volume-variant-v2 :volumes="volumesDetail" :legend-name="capacityText" :aria-label="legendCurrentVolume" :sfccvolumesdetails="variantDetail" :popup-dropdown="true" :productid="productIds" />
            </div>
            <div class="sticky__select--select_color" v-if="colorList.length > 0">
              <color-variant-v2 a11y-close-panel-text="panelText" a11y-next-panel-text="nextPanelText" a11y-previous-panel-text="previousPanelText" :colors="colorList" :legend-name="colorText" itemprop="color" :productid="productIds" :sfcccolorsdetails="colorsDetails" :popup-dropdown="true" />
            </div>
          </div>
        </div>
        <div class="sticky__buynow-button">
          <button type="button" class="actionBtn buyOnline" @click="buybuttonselect()"> {{ buynowTextData }} </button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import customSorting from '@Feature/CustomSorting/custom-sorting.vue';
  import VueSlickCarousel from 'vue-slick-carousel';
  import { tag, AnalyticsHandler } from '@Foundation/analyticsHandler';
  import ColorVariantV2 from '@Feature/ColorVariant-V2/code/Scripts/components/color-variant-v2';
  import VolumeVariantV2 from '@Feature/VolumeVariant-V2/code/Scripts/components/volume-variant-v2';
  export default {
    name: 'buynow',
    components: { VueSlickCarousel, ColorVariantV2,
                  VolumeVariantV2,customSorting },
    directives: {
      tag
    },
    props:	{
      requestData: { type: String, required: false, default: '' },
      isSingleVariant: { type: Boolean, default: false },
      capacityText: { type: String, required: false, default: 'Capacity' },
      colorText: { type: String, required: false, default: 'Color' },
      productId: { type: String, required: false, default: '' },
      buynowText: { type: String, required: true },
      buynowEventlabel: { type: String, required: false, default: 'Productname::Productean' },
      isOnline: { type: Boolean, required: false, default: false },
      productImg: { type: String, required: false, default: '' },
      stickyBuynowButton: { type: Boolean, required: false, default: false },
      pfdTitle: { type: String, required: false, default: '<strong>TOLERIANE</strong> <br/> SENSITIVE <br/>LE TEINT CREME' },
      variantDetail: { type: Array, required: false, default: [] },
      volumesDetail: { type: Array, required: false, default: [] },
      colorsDetails: { type: Array, required: false, default: [] },
      colorList: { type: Array, required: false, default: [] },
      productIds: { type: Array, required: false, default: [] },
      productName: { type: String, required: false, default: '' },
      productEan: { type: String, required: false, default: '' },
      tagEvent: { type: Boolean, required: false, default: false },
      routineProduct: { type: Boolean, required: false, default: false },
      routineMobile: { type: Boolean, required: false, default: false },
      ctaClass: {type: String, default: 'cta cta--light'},
      legendCurrentVolume: {type: String, required: false, default: 'legend-volume current-volume'},
      productPopinCtaClass: {type: String, default: ''},  
    },
    data() {
      return {
        dropdownItem: [],
        capacityPopup: false,
        sortField: 'title',
        settings: {
          'dots': true,
          'arrows': true,
          'infinite': false,
          'speed': 500,
          'slidesToShow': 4,
          'slidesToScroll': 4,
          'initialSlide': 0,
          'touchThreshold': 5,
          'responsive': [
            {
              'breakpoint': 1024,
              'settings': {
                'slidesToShow': 4,
                'slidesToScroll': 4,
                'infinite': false,
                'dots': true
              }
            },
            {
              breakpoint: 1023,
              settings: {
                'slidesToShow': 1,
                'slidesToScroll': 1,
                'dots': true,
                'arrows': true,
              }
            },
            {
              breakpoint: 768,
              settings: {
                vertical: true,
                verticalSwiping: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 0,
                speed: 15000,
                cssEase: 'linear',
                infinite: true,
                arrows: false,
                touchMove: true,
                swipeToSlide: true,
                swipe: true
              }
            },
          ]
        },
        eretailer: [],
        retailerDatas:[],
        eretailershops: [],
        shopsUnavailable: true,
        defaultDescriptionTitle: '',
        buynowTextData: this.buynowText,
        buynowEventlabelData: this.buynowEventlabel,
        showBuyNowButton: true,
        showPopup: false,
        show: 0,
        prescriptedValue: '',
        smallScreen: !window.matchMedia('(min-width: 1024px)').matches,
        isBuyOnline: this.isOnline,
        rangeListData: {},
        eanvalue: '',
        capacityMl:'',
      selectedInput: '',
      sortOrder: ''
      };
    },
    watch: {
    showPopup(newValue) {
      if (newValue) {
        this.sortOrder = '';
        this.$refs.retailer_sorting.selected = this.retailerDatas.defaultText;

      }
    }
  },
  computed: {
    
    sortedItems() { 
      if (!this.sortOrder) return this.eretailer[this.show].shops;
      return [...this.eretailer[this.show].shops].sort((a, b) => {
        if (this.sortOrder === 'asc') {
          return a[this.sortField].localeCompare(b[this.sortField]);
        } else {
          return b[this.sortField].localeCompare(a[this.sortField]);
        }
      });
    }
  },
    mounted() {
     window.eventBus.$on('selectProductIdValue', payload => {  
      if (payload) {
         this.capacityMl = payload;
      }
    });
      if(this.isSingleVariant) {
          this.apiFetch(this.requestData);
          this.productBuynowTag();
      }
      if (this.routineProduct) {
        this.buybuttonselect();
      }
      if(this.routineMobile){
       this.mobilebuybutton();
     }
      this.getUrlParam();
      let checkSections = document.querySelectorAll('.js-select-option');
      let numberOfChildren = checkSections && checkSections.length;
      if (numberOfChildren <= 0) {
        this.showBuyNowButton = false;
      }
      let elem = document.getElementsByClassName('popupContainer__bagIcon');
      if(elem.length >= 1){
        document.getElementsByClassName('popupContainer__bagIcon')[0].style.marginTop = 'auto';
      }
      window.eventBus.$on('showRetailerPopup',() => {
        setTimeout(() => {
          this.buybuttonselect();
        }, 300);
      });
      eventBus.$on('mediaquery::changed', () => {
        this.smallScreen = !window.matchMedia('(min-width: 1024px)').matches;
      }); 
    },

    methods: {
      getUrlParam() {
        const uri = window.location.href.split('?');
        if (uri.length == 2) {
          const vars = uri[1].split('&');
          const getVars = {};
          let tmp = '';
          vars.forEach(function(v) {
            tmp = v.split('=');
            if (tmp.length == 2) {
              getVars[tmp[0]] = tmp[1];
            }
          });
          if (getVars) {
            this.prescriptedValue = getVars;
          }
        }
      },
      setAnalytics(dataObject) {
        AnalyticsHandler.pushDataLayer(dataObject);
      },
      navigate: function(e) {
        if (e.target.dataset.show) {
          e.preventDefault();
          this.show = e.target.dataset.show;
        }
      },
      productBuynowTag() {
        AnalyticsHandler.pushDataLayer({
          'event': 'uaevent',
          'event_name': 'buy_now',
          'ecommerce': 'undefined',
          'eventCategory': 	'Ecommerce',
          'eventAction': 'click to buy',
          'eventLabel': `${this.removeHtmlAndSpecialChars([this.productName.toLowerCase()])}::${[this.productEan]}`,
          'product_info': `${this.removeHtmlAndSpecialChars([this.productName.toLowerCase()])}::${[this.productEan]}`,
        });
      },

      buybuttonselect() {
        if (this.tagEvent === true) {
          this.productBuynowTag();
        }

        this.closeCapacityPopupIfOpen();
        this.activateStickyWrapperIfNeeded();
        this.openBuyPopup();
        this.apiFetch(this.resolveProductItemId());
      },

      closeCapacityPopupIfOpen() {
        if (!this.capacityPopup) {
          return;
        }

        this.capacityPopup = false;
        document.getElementById('capacityPopupContainerOuter').classList.remove('showPopup');
      },

      activateStickyWrapperIfNeeded() {
        if (!this.isBuyOnline) {
          document.querySelector('.sticky-wrapper').classList.add('sticky-wrapper__active');
        }
      },

      openBuyPopup() {
        document.getElementById('popupContainerOuter').classList.remove('hidePopup');
        this.showPopup = true;

        if (document.body.classList.contains('is-using-keyboard')) {
          this.$nextTick(() => {
            this.$refs.accessibilityfocus?.focus();
          });
        }

        document.querySelector('.buyOnline')?.classList.add('buyOnline__active');
      },

      resolveProductItemId() {
        let dataIdChecked;

        if (this.rangeListData.israngelist) {
          dataIdChecked = this.rangeListData.commerceConnectorId;
        } else {
          dataIdChecked = this.getProductItemIdFromDom();
        }

        if (this.capacityMl) {
          dataIdChecked = this.capacityMl;
        }

        return dataIdChecked;
      },

      getProductItemIdFromDom() {
        const colorselectionid = document.querySelectorAll('.productItemId');
        const colorselectionChildren = colorselectionid && colorselectionid.length;

        if (colorselectionChildren > 0) {
          const colorselection = document.querySelectorAll('.productItemId')[0].textContent;

          return `{${colorselection}}`;
        }

        return this.getCheckedSelectOptionId();
      },

      getCheckedSelectOptionId() {
        const checkSections = document.querySelectorAll('.js-select-option');
        const numberOfChildren = checkSections && checkSections.length;

        if (numberOfChildren <= 0) {
          return undefined;
        }

        for (let i = 0; i < checkSections.length; i++) {
          const checkboxIds = checkSections[i].getAttribute('id');
          const checkedOnes = document.getElementById(checkboxIds).checked;

          if (checkedOnes === true) {
            return checkboxIds;
          }
        }

        return undefined;
      },
      apiFetch(dataIdChecked) { 
        fetch(`/api/sitecore/CommerceConnector/CommerceConnector?itemId=${dataIdChecked}&prescripted=${this.prescriptedValue.prescripted}`)
          .then(response => response.json())
          .then(jsonData => {
            this.eretailer = jsonData;
             this.retailerDatas = this.eretailer[0]?.retailerDictionaryDatas;
              this.dropdownItem = this.retailerDatas.sortByOptions;
          });
        this.showPopup = true;
      },
      closePopupScreen: function() {
        if (this.productId) {
          this.$emit('closepopup');
        }
        window.eventBus.$emit('closeProductpopin'); 
        window.eventBus.$emit('retailerbuynow', false);
        document.getElementById('popupContainerOuter').classList.add('hidePopup');
          
        document.querySelector('.sticky-wrapper')?.classList.remove('sticky-wrapper__active');
        document.querySelector('.buyOnline')?.classList.remove('buyOnline__active');
        document.body.style.removeProperty('overflow');
      
        this.showPopup = false;
    
      },
      mobilebuybutton: function() {
        //this.productBuynowTag();
        this.capacityPopup = true;
        this.showPopup = false;
        if(document.getElementById('capacityPopupContainerOuter')){
            document.getElementById('capacityPopupContainerOuter').classList.add('showPopup');
        }
        document.querySelector('.buyOnline').classList.add('buyOnline__active');
        document.body.style.overflow = 'hidden';
        document.getElementById('main').classList.add('variantPopup_active');
        document.querySelector('.capacityPopupContainerOuterroutine').classList.add('showPopup');
      },
      closecapacityPopupScreen: function() {
        this.capacityPopup = false;
        this.showPopup =false;
        window.eventBus.$emit('retailerbuynow', false);
        document.getElementById('capacityPopupContainerOuter').classList.remove('showPopup');
        document.querySelector('.buyOnline').classList.remove('buyOnline__active');
        document.body.style.removeProperty('overflow');
        document.getElementById('main').classList.remove('variantPopup_active');
      },
      removeHtmlAndSpecialChars(inputString) {
        // Create a DOMParser to parse the inputString as HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(inputString, 'text/html');
      
        // Get the plain text without HTML tags
        const plainText = doc.body.textContent || "";

        return plainText.replaceAll('\n', '');
    },
    }
  };

</script>
<style lang="scss" src="./buynow.scss"></style>
<style lang="scss" src="./vue-slick-carousel.scss"></style>
<style lang="scss" src="../../../../LrpRetailer/code/Scripts/components/lrp-retailer.scss"></style>
